import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";
import Swal from "sweetalert2";
import { studySiteDataEntryServices } from "../../../../APIServices/studySiteDataEntryServices";

const AssignFormSDVReviewer = ({
  Show,
  Hide,
  Title,
  formSDVData,
  userList,
  setUserList,
  getStudyFormSDVList
}) => {
  const [assignedUser, setAssignedUser] = useState([]);
  const [reviewLoader, setReviewLoader] = useState(false);
  const [dueDate, setDueDate] = useState("");
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getNextDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  };

  const assignReviewerStudyFormSDV = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to assign form field SDV reviewer!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, assign it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setReviewLoader(true);
        let userData = {}
        userData.studyId = studyId
        userData.siteId = formSDVData?.siteId
        userData.subjectId = formSDVData?.subjectId
        userData.schemaId = formSDVData?.schemaId
        userData.eventId = formSDVData?.eventId
        if(formSDVData?.timePointUniqueId){
          userData.timePointUniqueId = formSDVData?.timePointUniqueId
        }
        userData.formId = formSDVData?.formId
        userData.formVersion = formSDVData?.formVersion
        userData.formType = formSDVData?.formType
        userData.dataEntryType = formSDVData?.dataEntryType
        userData.updatedVersion = formSDVData?.updatedVersion
        if(formSDVData?.formType === "log"){
          userData.recordId = formSDVData?.recordId
        }
        userData.mode = StudyMode
        userData.assignedUser = assignedUser
        userData.dueDate = dueDate
        let data = await studySiteDataEntryServices.assignReviewerStudyFormSDV(userData);
        if (data?.statusCode === 200) {
          getStudyFormSDVList();
          Hide()
        }
      }
      setReviewLoader(false);
    });
  };

  useEffect(() => {
    setAssignedUser(formSDVData?.assignedUser || [])
    setDueDate(formSDVData?.dueDate || getNextDate())
  }, [formSDVData]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label>Assign User</Form.Label>
          <Form.Select
            multiple
            value={assignedUser}
            onChange={(e) => {
              const values = Array.from(
                e.target.selectedOptions,
                (option) => option.value
              );
              setAssignedUser(values);
            }}
          >
            {userList?.map((item, index) => (
              <option key={index} value={item?.userId}>
                {item?.fullName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Due Date</Form.Label>
          <Form.Control
            type="date"
            value={dueDate}
            min={new Date().toISOString().split("T")[0]}
            onChange={(e) => setDueDate(e.target.value)}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="p-2 hstack gap-2 bg-light border-top shadow-sm justify-content-end">
        <button
          className={`updateProfile`}
          onClick={assignReviewerStudyFormSDV}
          disabled={reviewLoader || !studyId || assignedUser?.length === 0}
          style={{ fontSize: 12 }}
        >
          {reviewLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" />
              Assigning
            </div>
          ) : (
            "Assign Reviewer"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default AssignFormSDVReviewer;
